import { render, staticRenderFns } from "./MetamaskWalletView.vue?vue&type=template&id=0fd3e82a&scoped=true&"
import script from "./MetamaskWalletView.vue?vue&type=script&lang=ts&"
export * from "./MetamaskWalletView.vue?vue&type=script&lang=ts&"
import style0 from "./MetamaskWalletView.vue?vue&type=style&index=0&id=0fd3e82a&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0fd3e82a",
  null
  
)

export default component.exports